import Search from "../form/Search";
import LimitSelect from "./LimitSelect";

const TableControls = ({ limit, totalDocs, onLimitChange, onSearch }) => {
  return (
    <div className="flex items-center gap-4 flex-wrap sm:flex-nowrap">
      <div className="w-full sm:w-36">
        <LimitSelect
          value={limit || 100}
          allValue={totalDocs}
          onChange={onLimitChange}
        />
      </div>
      <div className="w-full sm:w-72">
        <Search placeholder="Search here" search={onSearch} />
      </div>
    </div>
  );
};

export default TableControls;
